export default {
  methods: {
    isSortedByField (field) {
      const fields = Array.isArray(field) ? field : [field]
      const currentFiltersKeys = Object.keys(this.currentFilters)
      let isSortedBy = true
      fields.forEach(el => {
        if (!currentFiltersKeys.includes(`order[${el}]`)) isSortedBy = false
      })
      return isSortedBy
    },
    sortDirection (field) {
      if (!this.isSortedByField(field)) return false
      return this.currentFilters[`order[${field}]`]
    }
  }

}
